import { StateCreator } from "zustand";
import { FetchDayWiseVisitReportType } from "../../../domain/models/daily-visit-report/daily-visit-day-wise-report";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchDayWiseVisitReport } from "../../../domain/useages/daily-visit-report/fetchDayWiseVisitReport";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchDayWiseVisitReport } from "../../../data/usecases/daily-visit-report/remote-fetch-day-wise-visit-report";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchDayWiseVisitReportInterface {
  FetchDayWiseVisitReport: FetchDayWiseVisitReportType;
  FetchDayWiseVisitReportState: FetchState;
  fetchDayWiseVisitReport: Function;
}

const initialStates = {
  FetchDayWiseVisitReport: {} as FetchDayWiseVisitReportType,
  FetchDayWiseVisitReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchDayWiseVisitReportSlice: StateCreator<
  FetchDayWiseVisitReportInterface
> = (set) => ({
  ...initialStates,
  fetchDayWiseVisitReport: async (params: FetchDayWiseVisitReport.Params) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchDayWiseVisitReport = new RemoteFetchDayWiseVisitReport(
      `${BASE_URL}${Endpoints.FETCH_DAY_WISE_VISIT_REPORT}`,
      axiosHttpClient
    );

    set(() => ({ FetchDayWiseVisitReportState: FetchState.LOADING }));
    let result = await remoteFetchDayWiseVisitReport.fetch(params);
    set(() => ({
      FetchDayWiseVisitReport: result,
      FetchDayWiseVisitReportState: FetchState.SUCCESS,
    }));
  },
});
